import { useEffect, type FC } from 'react';
import Cookies from 'js-cookie';
import { Heading } from '@livechat/design-system-react-components';

import { Product } from 'types/product';
import { PRODUCTS } from 'constants/product';
import { Layout } from 'components/layout/Layout';
import { detectProduct } from 'helpers/product';

import { TrialProductCard } from './TrialProductCard';

import * as styles from './styles';

type Props = {
  isLoggedIn?: boolean;
};

export const SelectTrial: FC<Props> = ({ isLoggedIn = false }) => {
  useEffect(() => {
    Cookies.remove('product');

    if (detectProduct() !== Product.Undefined && !isLoggedIn) {
      const queryParams = window.location.search;
      window.location.href = `/signup${queryParams}`;
    }
  }, []);

  const chooserContent = () => (
    <div css={styles.containerStyles}>
      <Heading css={styles.headingStyles} size="lg">
        Choose a product to start trial
      </Heading>
      <div css={styles.cardsContainerStyles}>
        {PRODUCTS.map((product) => (
          <TrialProductCard
            product={Product[product]}
            isLoggedIn={isLoggedIn}
            key={product}
            fullWidth={product === 'TextApp'}
          />
        ))}
      </div>
    </div>
  );

  if (isLoggedIn) {
    return <Layout backToLogin>{chooserContent()}</Layout>;
  }

  return <Layout showAlreadyHaveAnAccount>{chooserContent()}</Layout>;
};
